import { forwardRef } from 'react';
import { components, MenuProps, SingleValueProps } from 'react-select';
import AsyncSelect from 'react-select/async';

import { SelectOption } from '~/shared/utils/types';

import { CommonSelectProps, SearchIndicator, useCommonSelectProps, Option } from './helpers';

const EmptyOnSelectSingleValue = function <T>(props: SingleValueProps<T, false>) {
  const { children, ...rest } = props;
  const possiblyInvisibleValue = props.selectProps.value ? (
    <span>{props.selectProps.placeholder}</span>
  ) : (
    children
  );
  return <components.SingleValue {...rest}>{possiblyInvisibleValue}</components.SingleValue>;
};

const Menu = function <T>(props: MenuProps<T, false>) {
  return (
    <>
      <components.Menu {...props}>{props.children}</components.Menu>
    </>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SingleAutocomplete = forwardRef<any, CommonSelectProps<SelectOption, false>>((props, ref) => {
  const common = useCommonSelectProps(props);
  return (
    <AsyncSelect<SelectOption, false>
      ref={ref}
      autoFocus={props.autoFocus}
      menuPlacement={'auto'}
      key={props?.key}
      components={{
        DropdownIndicator: SearchIndicator,
        SingleValue: EmptyOnSelectSingleValue,
        Option: props.customizedOptions ? props.customizedOptions : Option,
        Menu: props.customMenu ? props?.customMenu : Menu,
      }}
      menuIsOpen={props?.menuIsOpen}
      {...common}
    />
  );
});

SingleAutocomplete.displayName = 'SingleAutocomplete';

export default SingleAutocomplete;
